import getGenders from '../../data/getGenders'

const isGender = maybeGender => {
  const GENDERS = getGenders()
  const GENDER_VALUES = GENDERS.map(gender => gender.value)
  const gender = parseInt(maybeGender, 10)
  return typeof gender === 'number' && GENDER_VALUES.includes(gender)
}

export default isGender
